import React from "react";
import classNames from "classnames";

type Props = typeof defaultProps;

const defaultProps = {
  label: "",
  helpText: "" as string | React.ComponentType,
  name: "",
  placeholder: "",
  textareaProps: {} as React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
  inputExtraClasses: "",
  required: false,
  invalid: false,
};

export const TextareaField: React.FunctionComponent<Partial<
  Props
>> = partials => {
  const props = { ...defaultProps, ...partials };

  const inputClassName = classNames(
    "input-group",
    { "is-required": props.required },
    props.inputExtraClasses
  );
  return (
    <div className="form-group">
      {props.label && <label className="form-input-label">{props.label}</label>}
      <div className={inputClassName}>
        <textarea
          name={props.name}
          className="form-control"
          placeholder={props.placeholder}
          {...props.textareaProps}
        />
      </div>
      {props.helpText &&
        (typeof props.helpText === "string" ? (
          <small className="form-text text-muted">{props.helpText}</small>
        ) : (
          props.helpText
        ))}
    </div>
  );
};
